// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This demonstrates the themeing support */


/* defaults */

/*
:root {
  --calc-bg-color: white;
  --calc-primary-color: #00437c;
  --calc-secondary-color: #5cb852;
  --calc-font-family: 'Work Sans';
}
*/


/*
:root {
  --calc-bg-color: brown;
  --calc-primary-color: green;
  --calc-secondary-color: yellow;
  --calc-font-family: sans-serif;
}
*/

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,2CAA2C;;;AAG3C,aAAa;;AAEb;;;;;;;CAOC;;;AAGD;;;;;;;CAOC","sourcesContent":["/* This demonstrates the themeing support */\n\n\n/* defaults */\n\n/*\n:root {\n  --calc-bg-color: white;\n  --calc-primary-color: #00437c;\n  --calc-secondary-color: #5cb852;\n  --calc-font-family: 'Work Sans';\n}\n*/\n\n\n/*\n:root {\n  --calc-bg-color: brown;\n  --calc-primary-color: green;\n  --calc-secondary-color: yellow;\n  --calc-font-family: sans-serif;\n}\n*/\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
